export const environment = {
  production: false,
  enableKeycloakDirectLogin: true,
  customer: "nafed-mc",
  iamhost: "https://assaying-dev.qualix.ai/portal/",
  dcmhost: "https://assaying-dev.qualix.ai/portal/",
  scmhost: "https://assaying-dev.qualix.ai/portal/",
  reactivehost: "https://assaying-dev.qualix.ai/portal2/",
  
  keycloak: {
    url: "https://dev.perfeqtfoods.com/keycloak",
    realm: "CentralIAM",
    clientId: "qualix-frontend",
    logoutRedirectUri: 'https://assaying-dev.qualix.ai'
  },

  gatewayUrl: 'https://dev.perfeqtfoods.com/api/asu/gateway',
  assayingPath: 'assaying-dev',
  iframeParentOrigin: '*',
};
